import React, { FC } from 'react';
import { Filter } from 'react-admin';
import Box from '@material-ui/core/Box';
import { LazyReferenceInput } from 'components/LazyAutoCompleteInput';

export const ModelBoardSheetFilters: FC<any> = props => {
  return (
    <Box>
      <Filter {...props}>
        <LazyReferenceInput
          label="Builder"
          source="builderId"
          reference="builder"
          resettable
          data-cy="masterSheetFilterBuilder"
          alwaysOn
          allowEmpty={false}
          filterToQuery={value => (value ? { name: value } : {})}
          sort={{ field: 'name', order: 'ASC' }}
          optionText="name"
          optionValue="id"
        />
        <LazyReferenceInput
          label="Subdivision"
          source="subdivisionId"
          reference="subdivision"
          resettable
          data-cy="masterSheetFilterSubdivision"
          alwaysOn
          allowEmpty={false}
          filterToQuery={value => (value ? { name: value } : {})}
          sort={{ field: 'name', order: 'ASC' }}
          optionText="name"
          optionValue="id"
        />
        <LazyReferenceInput
          label="Model"
          source="modelId"
          reference="model"
          resettable
          data-cy="masterSheetFilterModel"
          alwaysOn
          allowEmpty={false}
          filterToQuery={value => (value ? { name: value } : {})}
          sort={{ field: 'name', order: 'ASC' }}
          optionText="name"
          optionValue="id"
        />
      </Filter>
    </Box>
  );
};
